import React, { Component } from "react";
import Quagga from "quagga";

export default class Scanner extends Component {
  constructor(props) {
    super(props);
    this._onDetected = this._onDetected.bind(this);
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.startScanner();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen && !this.props.isOpen) {
      this.stopScanner();
    } else if (!prevProps.isOpen && this.props.isOpen) {
      this.startScanner();
    }
  }

  componentWillUnmount() {
    this.stopScanner();
  }

  startScanner() {
    Quagga.init(
      {
        inputStream: {
          type: "LiveStream",
          constraints: {
            width: 640,
            height: 480,
            facingMode: "environment", // or user
          },
        },
        locator: {
          patchSize: "medium",
          halfSample: true,
        },
        numOfWorkers: 2,
        decoder: {
          readers: ["code_128_reader"],
        },
        locate: true,
      },
      (err) => {
        if (err) {
          return console.log(err);
        }
        Quagga.start();

        // Remove the canvas element after Quagga initializes
        const drawingCanvas = document.querySelector(".drawingBuffer");
        if (drawingCanvas) {
          drawingCanvas.remove();
        }
      },
    );
    Quagga.onDetected(this._onDetected);
  }

  stopScanner() {
    Quagga.offDetected(this._onDetected);
    Quagga.stop();
  }

  _onDetected(result) {
    this.props.onDetected(result);
  }

  render() {
    return <div id="interactive" className="viewport" />;
  }
}
